/**
 * 电子游戏首页
 */
import ReactDOM from "react-dom";
import {connect} from 'react-redux'
import RichHeader from './RichHeader.jsx';
import MainFooter from '../../components/footers/Original_Main.jsx'
import SideBar from '../../components/affix/SideBar.jsx';
import Entrance from '../../components/entrance/entrance.jsx';

class Slot extends React.Component {

  constructor(props) {
    super(props);
    this.state = {
      createUserDisplay: false,
      domainName:false
    }
  }

  componentDidMount() {
    this.setState({
      domainName:window.location.hostname.indexOf('hengy800')!==-1
    })
  }

  openTransfer(platfrom) {
    this.props.$$BASE.openOverlay();
    this.props.$$BASE.openTransferModal(platfrom)
  }

  // 进入游戏
  enterGame(url, platform) {
    const __user = this.props.__USER.toJS();
    // kgame需要先判断平台是否可用
    if (platform == 'kgame') {
      window.location.href = '#/slot';
      // 还未加载完成
      if (!__user.platform_profile.kgame.onload) {
        return this.props.$$BASE.openToast('平台数据加载中，请稍后...');
      }
      // 平台不可用
      if (!__user.platform_profile.kgame.available) {
        this.props.$$BASE.openOverlay();
        this.setState({
          createUserDisplay: true
        })
        return;
      }

      // 平台可用
      window.open(url);
      return;
    }

    window.location.href = url;
  }

  // 隐藏创建用户
  closeCreateUserModal() {
    this.props.$$BASE.closeOverlay();
    this.setState({
      createUserDisplay: false
    })
  }

  // 创建平台用户
  createPlatformUser(platform) {
    // 用户名，密码，昵称
    let username, password;
    username = ReactDOM.findDOMNode(this.refs.kname).value
    password = ReactDOM.findDOMNode(this.refs.kpass).value
    const reg1 = /\w{5,17}/;
    const reg2 = /\w{6,30}/;
    const reg3 = /\w/;
    if (username == "") {
      this.props.$$BASE.openAlert("用户名不能为空")
      return
    }
    if (!reg1.test(username)) {
      this.props.$$BASE.openAlert("用户名格式错误")
      return
    }
    if (password == "") {
      this.props.$$BASE.openAlert("密码不能为空")
      return
    }
    if (!reg2.test(password)) {
      this.props.$$BASE.openAlert("密码格式错误")
      return
    }
    this.props.$$USER.createPlatformAccount(platform, username, password);
    this.props.$$BASE.closeOverlay();
    this.setState({
      createUserDisplay: false
    })
  }


  render() {

    const __user = this.props.__USER.toJS();
    const {domainName}=this.state
    return (
        <div className="slot-bg">
          <div>
            <RichHeader/>
            <SideBar/>
            <div className="zryx_banner dzyx_banner clearfix">
              <div className="content-slot">
                <div className="zryx">
                  <Entrance money={__user.balance.pt} gameName="PT" imgname='dy-playtech'
                            transferFn={this.openTransfer.bind(this, "PT")} url="#/game/pt/slot" type="slot"/>
                </div>
                    <div className="zryx" style={{display:domainName?'none':''}}>
                      <Entrance money={__user.balance.ag} gameName="AG" imgname='dy-ag'
                                transferFn={this.openTransfer.bind(this, "AG")} url="#/game/ag/slot" type="slot"/>
                    </div>
                <div className="zryx">
                  <Entrance money={__user.balance.bbin} gameName="BBIN" imgname='dy-bbin'
                            transferFn={this.openTransfer.bind(this, "BBIN")} url="#/game/bbin/slot" type="slot"/>
                </div>
              </div>
            </div>
            <MainFooter/>
          </div>
          {
            this.state.createUserDisplay ?
                <div className="kgame-container">
                  <div>
                    <h2>请创建您的KGAME账户</h2>
                    <ul>
                      <li>
                        <label>用&nbsp;&nbsp;户&nbsp;&nbsp;名：</label>
                        <input type="text" placeholder="请输入用户名" ref="kname"/>
                        <span>由5-17位字符组成（不允许有特殊字符）</span>
                      </li>
                      <li>
                        <label>登录密码：</label>
                        <input type="password" placeholder="请输入密码" ref="kpass"/>
                        <span>由6-30位字符组成（不允许有特殊字符）</span>
                      </li>
                      <li>
                        <button onClick={this.createPlatformUser.bind(this, "kgame")}>确&nbsp;&nbsp;&nbsp;&nbsp;定
                        </button>
                      </li>
                    </ul>
                    <span className="close-btn" onClick={this.closeCreateUserModal.bind(this)}>X</span>
                  </div>
                </div>
                : null
          }
        </div>
    )
  }
}

reactMixin(Slot.prototype, ImmutableMixin);

function mapStateToProps(state) {
  return {
    __USER: state.user
  }
}

function mapDispatchToProps(dispatch) {
  return {
    $$USER: bindActionCreators(userAction, dispatch),
    $$BASE: bindActionCreators(baseAction, dispatch)
  }
}

export default connect(
    mapStateToProps,
    mapDispatchToProps
)(Slot)